import React from "react"

const Page14Mobile = ({ backgroundColor, openPercent, color, innerRef }) => {
  return (
    <div ref={innerRef} style={{ background: backgroundColor, color: color }} className="grid-cols-4 md:grid-cols-8">
      <div className='col-4 md:col-6 md:col-offset-left-1'>
        <div className='mt-2 font-family-acumin font-18 line-height-24'>4 / 4</div>
        <div className='mt-2 font-16 line-height-20 font-uppercase'>Come funziona fleet audit</div>
        <div className='mt-2 font-40 line-height-58 font-family-acumin font-weight-900'>
          Guarda che
          innovazione
        </div>
        <div className='mt-4 mb-5 font-20 line-height-26'>
          Dai dati cruciali rilevati alla fattbilità della transizione,
          fino alla reportistica: una panoramica sui vantaggi di Fleet Audit.
        </div>
      </div>
    </div>
  )
}

export default Page14Mobile
